export const navLinks = [
  { navLinkId: "HOME", scrollToId: "homeContainer" },
  { navLinkId: "SERVICES", scrollToId: "serviceContainer" },
  { navLinkId: "GALLERY", scrollToId: "photosContainer" },
  { navLinkId: "CONTACT", scrollToId: "contactContainer" },
  { navLinkId: "ABOUT US", scrollToId: "aboutContainer" },
];
